export const ACTION_LOAD_FAVICON__REQUEST = 'ACTION_LOAD_FAVICON__REQUEST';
export const ACTION_LOAD_FAVICON__FAIL = 'ACTION_LOAD_FAVICON__FAIL';
export const ACTION_LOAD_FAVICON__SUCCESS = 'ACTION_LOAD_FAVICON__SUCCESS';

export const ACTION_UPLOAD_FAVICON__REQUEST = 'ACTION_UPLOAD_FAVICON__REQUEST';
export const ACTION_UPLOAD_FAVICON__FAIL = 'ACTION_UPLOAD_FAVICON__FAIL';
export const ACTION_UPLOAD_FAVICON__SUCCESS = 'ACTION_UPLOAD_FAVICON__SUCCESS';

export const ACTION_DELETE_FAVICON__REQUEST = 'ACTION_DELETE_FAVICON__REQUEST';
export const ACTION_DELETE_FAVICON__FAIL = 'ACTION_DELETE_FAVICON__FAIL';
export const ACTION_DELETE_FAVICON__SUCCESS = 'ACTION_DELETE_FAVICON__SUCCESS';
